import { dismissAllHintsAndDialogsKey } from '../constants';
import { safeLocalStorage } from './safeStorage';

/**
 * @description Returns true if hints and onboarding dialogs should be displayed.
 * Returns false when running in Cypress with dismissAllHintsAndDialogs (key set in localStorage).
 * @returns {boolean} true if hints and onboarding dialogs should be displayed.
 */
export const shouldDisplayHintsAndOnboardingDialogs = (): boolean =>
  safeLocalStorage.getItem(dismissAllHintsAndDialogsKey) !== 'true';

/**
 * @description Sets whether hints and onboarding dialogs should be displayed.
 * When false, the key is set so shouldDisplayHintsAndOnboardingDialogs() returns false (e.g. Cypress).
 * @param {boolean} shouldDisplay - true if hints and onboarding dialogs should be displayed.
 */
export const setShouldDisplayHintsAndOnboardingDialogs = (shouldDisplay: boolean) => {
  safeLocalStorage.setItem(dismissAllHintsAndDialogsKey, shouldDisplay ? 'false' : 'true');
};
